import React, { useState, useEffect, useContext } from "react";
import {
  Modal,
  Row,
  Typography,
  Col,
  Input,
  Form,
  DatePicker,
  Radio,
  Select,
  message,
  Table,
  Divider,
  Checkbox,
  Popconfirm,
  Button,
  Icon,
  Empty,
  Tag,
  Tabs,
} from "antd";
import moment from "moment";
import "./index.less";

import { formatValue } from "../../../../utils";
import { withRouter, Link } from "react-router-dom";
import { ContextAPI } from "../../../../ContextAPI";
import { platformApi } from "../../../../api";
import AssociatedVehicle from "./Associated Vehicles";
import AssociatedBookings from "./AssociatedBookings";
import AssociatedQuotations from "./AssociatedQuotations";
import AssociatedSpares from "./AssociatedSpares"
import AssociatedJobOrder from "./AssociatedJobOrder"
import CallHistory from "./CallHistory";
import AssociatedNumberPlates from './AssociatedNumberPlates'
import AssociatedPayments from './AssociatedPayments'

const { Item } = Form;
const { Title, Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const CustomerDetailsForm = (props) => {
  let { cusId, setCusId, isCall, refreshData } = props;
  const [referredList, setReferredList] = useState([]);
  const [delData, setDelData] = useState([]);
  const [gstType, setGstType] = useState(true);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [district, setDistrict] = useState([]);
  const [localities, setLocalities] = useState([]);
  const [shippingStates, setShippingStates] = useState([]);
  const [shippingCities, setShippingCities] = useState([]);
  const [shippingDistricts, setShippingDistricts] = useState([]);
  const [shippingLocalities, setShippingLocalities] = useState([]);
  const [country, setCountry] = useState([]);
  const [date, setDate] = useState("default");
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(props.phone != undefined ? true : props.editable);
  const [dataSource, setDataSource] = useState([]);
  const [editPhone, setEditPhone] = useState("");
  const [error, setError] = useState({});
  const [checkAll, setCheckAll] = useState(true);
  const [checkName, setCheckName] = useState(true);
  const [checkNameNo, setCheckNameNo] = useState(true);
  const [gstName, setGstName] = useState("");
  const [primaryNumberCheck, setPrimaryNumberCheck] = useState(false);
  const [gstStatus, setGstStatus] = useState("");
  const [sameAsBilling, setSameAsBilling] = useState(false);
  const [shippingAddress, setShippingAddress] = useState({
    line1: "",
    line2: "",
    line3: "",
    locality: "",
    pincode: "",
    country: "",
    state: "",
    city: "",
    district: ""
  });
  const { form, open, close, selectedData, data } = props;
  const { getFieldDecorator, getFieldValue } = form;
  // const [data,setData] = useState(); 
  const [activeKey, setActiveKey] = useState("1");

  const types = [
    { key: "Primary", title: "Primary" },
    { key: "Alternate", title: "Alternate" },
  ];
  const { loginCredintials } = useContext(ContextAPI);

  const column = [
    {
      title: <Text strong>Phone Number</Text>,
      dataIndex: "phone",
      key: "phone",
      render: (record) => <span>{record}</span>,
    },
    {
      title: <Text strong>Type</Text>,
      dataIndex: "type",
      key: "type",
      render: (record) => <span>{record}</span>,
    },
    {
      title: <Text strong>Validity</Text>,
      dataIndex: "valid",
      key: "valid",
      render: (record) => (record ? "Valid" : "Invalid"),
    },
    {
      title: <Text strong>WhatsApp</Text>,
      dataIndex: "WhatsApp",
      key: "WhatsApp",
      render: (record) => (record ? "Yes" : "No"),
    },
    {
      title: <Text strong>DND</Text>,
      dataIndex: "DND",
      key: "DND",
      render: (record) => (record ? "Yes" : "No"),
    },
    {
      title: <Text strong>Action</Text>,
      render: (Data) => (
        <div>
          {Data.id ? (
            <span>
              <Icon
                onClick={(event) => {
                  event.stopPropagation();
                  setEditPhone(Data.id);
                  form.setFieldsValue({
                    phone: Data.phone,
                    type: Data.type,
                    valid: Data.valid,
                    WhatsApp: Data.WhatsApp,
                    dnd: Data.DND,
                  });
                }}
                type="edit"
              />
              <Divider type="vertical" />
            </span>
          ) : (
            <span />
          )}
          {dataSource.length === 1 && data ? (
            <span></span>
          ) : (
            <Popconfirm
              title="Do you want to delete this Mobile Number?"
              okText="Yes"
              cancelText="No"
              onCancel={(event) => {
                event.stopPropagation();
              }}
              onConfirm={(event) => {
                event.stopPropagation();
                setDelData(Data);
                let data = dataSource.filter(
                  (data) => data.phone !== Data.phone
                );
                setDataSource(data);
              }}
            >
              <Icon
                type="delete"
                onClick={(event) => event.stopPropagation()}
              />
            </Popconfirm>
          )}
        </div>
      ),
    },
  ];

  const deleteData = (dData) => {
    if (dData.id) {
      platformApi.delete(`api/customer/phone/${dData.id}`).then((res) => {
        if (res.data.response.code === 200) {
          setDataSource([]);
          let data = dataSource.filter((data) => data.phone !== dData.phone);
          setDataSource(data);
        } else {
          message.error("Phone Not Deleted");
        }
      });
    } else {
      setDataSource([]);
      const data = dataSource.filter((data) => data.phone !== dData.phone);
      setDataSource(data);
    }
  };

  const salutations = [
    { key: "Mr", title: "Mr" },
    { key: "Mrs", title: "Mrs" },
    { key: "Ms", title: "Ms" },
    { key: "Miss", title: "Miss" },
    { key: "M/S", title: "M/S" },
  ];

  const customerTypes = [
    { key: "Sales Customer", title: "Sales Customer" },
    { key: "Service Customer", title: "Service Customer" },
    { key: "Non Customer", title: "Non Customer" },
    ...(data?.customerType === "Insurance Surveyor"
      ? [{ key: "Insurance Surveyor", title: "Insurance Surveyor" }]
      : []),
  ];
  const customerGrouping = [
    { key: "Individual", title: "Individual" },
    { key: "Non-Individual", title: "Non-Individual" },
  ];

  const contactData = () => {
    if (dataSource.length === 0) {
      setError({
        ...error,
        CONTACTS: {
          type: "error",
          message: "Enter Atleast One Contact",
        },
      });
    } else {
      delete error.CONTACTS;
      setError(error);
    }
  };
  function checkGST(gst) {
    platformApi.post("/api/gstVerify", { gst }).then((res) => {
      let { data } = res;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          if (response.data.data.error) {
            message.error("GST Invalid");
            setGstName("");
            setGstStatus("");
            return false;
          } else {
            message.success("GST Verified");
            delete error.GST;
            setError(error);
            setGstName(response.data.data.taxpayerInfo.tradeNam);
            setGstStatus(response.data.data.taxpayerInfo.sts);
            return true;
          }
        }
      }
    });
  }

  useEffect(() => {
    numberCheck(dataSource);
  }, [dataSource]);

  const numberCheck = (data) => {
    let flag = false;
    data?.map((each) => {
      if (each.type === "Primary") {
        setPrimaryNumberCheck(true);
        flag = true;
        form.setFieldsValue({
          type: "Alternate",
        });
      }
    });
    if (!flag) {
      setPrimaryNumberCheck(false);
      form.setFieldsValue({
        type: "Primary",
      });
    }
  };

  const handleSubmit = () => {
    form.validateFields(async (validationError) => {
      if (
        validationError === null &&
        (JSON.stringify({}) === JSON.stringify(error) || error.length == 0) &&
        !error.EMAIL
      ) {
        setLoading(true);
        if (dataSource.length == 0) {
          message.error("Enter Phone Number");
          setLoading(false);
        } else if (
          dataSource.length !== 0 ||
          (!checkAll && form.getFieldValue("name"))
        ) {
          const salutation = form.getFieldValue("salutation");
          const name = form.getFieldValue("name");
          const fatherName = form.getFieldValue("fatherName");
          const gender = form.getFieldValue("gender");
          let dob = form.getFieldValue("dateOfBirth");
          const dateOfBirth = dob ? dob.format("DD-MM-YYYY") : undefined;
          const country = form.getFieldValue("country");
          const city = form.getFieldValue("city");
          const district = form.getFieldValue("district");
          const state = form.getFieldValue("state");
          // const street = form.getFieldValue("street");
          const line1 = form.getFieldValue("line1");
          const line2 = form.getFieldValue("line2");
          const line3 = form.getFieldValue("line3");
          const rawLocality = form.getFieldValue("locality");
          const locObj = localities.find((l) => l.id === rawLocality || l.localityName === rawLocality);
          const locality = locObj ? locObj.localityName : (rawLocality || "");
          const pincode = form.getFieldValue("pincode");
          const customerType = form.getFieldValue("customerType");
          const GSTNo = form.getFieldValue("GSTNo") || null;
          const GSTType = form.getFieldValue("GSTType");
          const customerGrouping = form.getFieldValue("customerGrouping");
          const refferedBy = form.getFieldValue("referredBy") || 0;
          const reffered = form.getFieldValue("referred");
          const email = form.getFieldValue("email");
          const aadhaarNo = form.getFieldValue("aadhaarNo");
          const panCardNo = form.getFieldValue("panCardNo");
          let shippingAddressData = {};
          if (sameAsBilling) {
            // Use billing address for shipping
            shippingAddressData = {
              shippingline1: line1,
              shippingline2: line2,
              shippingline3: line3,
              shippinglocality: locality,
              shippingpincode: pincode,
              shippingcountry: country,
              shippingstate: state,
              shippingcity: city,
              shippingdistrict: district
            };
          } else {
            // Get separate shipping address values
            const rawShipLoc = form.getFieldValue("shippingLocality");
            const shipLocObj = shippingLocalities.find((l) => l.id === rawShipLoc || l.localityName === rawShipLoc);
            const shippinglocality = shipLocObj ? shipLocObj.localityName : (rawShipLoc || "");
            shippingAddressData = {
              shippingline1: form.getFieldValue("shippingLine1") || "",
              shippingline2: form.getFieldValue("shippingLine2") || "",
              shippingline3: form.getFieldValue("shippingLine3") || "",
              shippinglocality: shippinglocality,
              shippingpincode: form.getFieldValue("shippingPincode") || "",
              shippingcountry: form.getFieldValue("shippingCountry") || "",
              shippingstate: form.getFieldValue("shippingState") || "",
              shippingcity: form.getFieldValue("shippingCity") || "",
              shippingdistrict: form.getFieldValue("shippingDistrict") || ""
            };
          }

          let customerId = "";
          const IDbranch = loginCredintials.branch.id;
          if (delData && delData?.length > 1) {
            for (let i = 0; i < delData?.length; i++) {
              deleteData(delData[i]);
            }
          } else if (delData) {
            deleteData(delData);
          }
          if (!data) {
            await platformApi.post("/api/idGenerate/customer").then((res) => {
              let { data } = res;
              if (data.code === 200) {
                let { response } = data;
                customerId = response.data;
              } else {
                message.error("Couldn't fetch id");
              }
            });
          } else {
            customerId = cusId;
          }
          const customer = {
            customerId,
            salutation,
            name,
            fatherName,
            gender,
            contacts: dataSource,
            dateOfBirth,
            address: {
              city,
              district,
              state,
              country,
              // street,
              line1,
              line2,
              line3,
              locality,
              pincode,
            },
            shippingAddress: shippingAddressData,
            customerType,
            GSTNo,
            GSTType,
            customerGrouping,
            refferedBy,
            reffered,
            IDbranch,
            email,
            aadhaarNo,
            panCardNo,
          };
          data ? (customer.id = data.id) : {};
          setLoading(false);
          props.emitData(customer);
          props.close();
          form.resetFields();
          setCusId("");
          setLoading(false);
          setState([]);
          setCity([]);
          setDistrict([]);
          setShippingStates([]);
          setShippingCities([]);
          setShippingDistricts([]);
          setDataSource([]);
          setCheckAll(true);
          setCheckNameNo(true);
          setSameAsBilling(false);
          setShippingAddress({
            line1: "",
            line2: "",
            line3: "",
            locality: "",
            pincode: "",
            country: "",
            state: "",
            city: "",
            district: ""
          });
        } else if (!form.getFieldValue("name")) {
          message.error("Enter Phone Number");
          setLoading(false);
        } else {
          message.error("Enter Phone Number");
          setLoading(false);
        }
      }
    });
  };

  const handleSameAsBillingChange = (e) => {
    const checked = e.target.checked;
    setSameAsBilling(checked);

    if (checked) {
      // Copy billing address to shipping address fields
      const billingLine1 = getFieldValue("line1") || "";
      const billingLine2 = getFieldValue("line2") || "";
      const billingLine3 = getFieldValue("line3") || "";
      const billingLocality = getFieldValue("locality") || "";
      const billingPincode = getFieldValue("pincode") || "";
      const billingCountry = getFieldValue("country") || "";
      const billingState = getFieldValue("state") || "";
      const billingCity = getFieldValue("city") || "";
      const billingDistrict = getFieldValue("district") || "";

      // Set shipping address fields to billing values
      form.setFieldsValue({
        shippingLine1: billingLine1,
        shippingLine2: billingLine2,
        shippingLine3: billingLine3,
        shippingLocality: billingLocality,
        shippingPincode: billingPincode,
        shippingCountry: billingCountry,
        shippingState: billingState,
        shippingCity: billingCity,
        shippingDistrict: billingDistrict
      });

      // Update shipping address state
      setShippingAddress({
        line1: billingLine1,
        line2: billingLine2,
        line3: billingLine3,
        locality: billingLocality,
        pincode: billingPincode,
        country: billingCountry,
        state: billingState,
        city: billingCity,
        district: billingDistrict
      });

      // Copy state, city and district lists to shipping equivalents
      setShippingStates(state || []);
      setShippingCities(city || []);
      setShippingDistricts(district || []);
      setShippingLocalities(localities || []);

      // Clear any validation errors for shipping fields since they are copied
      const nextError = { ...error };
      delete nextError.SHIPPING_PIN;
      delete nextError.SHIPPING_LOCALITY;
      delete nextError.SHIPPING_LINE1;
      delete nextError.SHIPPING_LINE2;
      delete nextError.SHIPPING_DOOR;
      setError(nextError);
    }
  };

  useEffect(() => {
    if (sameAsBilling) {
      const billingLine1 = getFieldValue("line1") || "";
      const billingLine2 = getFieldValue("line2") || "";
      const billingLine3 = getFieldValue("line3") || "";
      const billingLocality = getFieldValue("locality") || "";
      const billingPincode = getFieldValue("pincode") || "";
      const billingCountry = getFieldValue("country") || "";
      const billingState = getFieldValue("state") || "";
      const billingCity = getFieldValue("city") || "";
      const billingDistrict = getFieldValue("district") || "";

      form.setFieldsValue({
        shippingLine1: billingLine1,
        shippingLine2: billingLine2,
        shippingLine3: billingLine3,
        shippingLocality: billingLocality,
        shippingPincode: billingPincode,
        shippingCountry: billingCountry,
        shippingState: billingState,
        shippingCity: billingCity,
        shippingDistrict: billingDistrict
      });

      setShippingAddress({
        line1: billingLine1,
        line2: billingLine2,
        line3: billingLine3,
        locality: billingLocality,
        pincode: billingPincode,
        country: billingCountry,
        state: billingState,
        city: billingCity,
        district: billingDistrict
      });

      // Copy state, city and district lists to shipping equivalents
      setShippingStates(state || []);
      setShippingCities(city || []);
      setShippingDistricts(district || []);
      setShippingLocalities(localities || []);

      // Clear any validation errors for shipping fields since they are copied
      setError((prevErrors) => {
        const nextError = { ...prevErrors };
        delete nextError.SHIPPING_PIN;
        delete nextError.SHIPPING_LOCALITY;
        delete nextError.SHIPPING_LINE1;
        delete nextError.SHIPPING_LINE2;
        delete nextError.SHIPPING_DOOR;
        return nextError;
      });
    }
  }, [
    getFieldValue("line1"),
    getFieldValue("line2"),
    getFieldValue("line3"),
    getFieldValue("locality"),
    getFieldValue("pincode"),
    getFieldValue("country"),
    getFieldValue("state"),
    getFieldValue("city"),
    getFieldValue("district"),
    state,
    city,
    district
  ]);

  useEffect(() => {
    if (!open || !selectedData || !isCall) return;

    const {
      numberPlates = [],
      spareOrders = [],
      customer = {},
      jobOrders = [],
      telecmiCallHistory = [],
    } = selectedData;

    const {
      booking = [],
      quotation = [],
      purchasedVehicle = []
    } = customer;

    // Priority-based tab logic
    if (numberPlates.some(p => ["RECEIVED", "ORDERED"].includes(p.plateOrderStatus))) {
      setActiveKey("8"); // Number Plates
    } else if (spareOrders.length > 0) {
      setActiveKey("6"); // Spare Orders
    } else if (booking.length > 0) {
      setActiveKey("3"); // Bookings
    } else if (jobOrders.length > 0) {
      setActiveKey("5"); // Job Orders
    } else if (quotation.length > 0) {
      setActiveKey("4"); // Quotations
    } else if (customer.payments && customer.payments.length > 0) {
      setActiveKey("9"); // Payments
    } else if (purchasedVehicle && purchasedVehicle.length > 0) {
      setActiveKey("2"); // associated vehicle
    } else if (telecmiCallHistory.length > 0 || isCall) {
      setActiveKey("7"); // Call History
    } else {
      setActiveKey("1"); // Default - Customer Details
    }
  }, [open, isCall, selectedData]);


  useEffect(() => {
    if (open) {
      platformApi
        .get("/api/csc/country")
        .then((result) => {
          const { data: resData } = result;
          if (resData.code === 200) {
            setCountry(resData.data);
            if (!data) {
              const defaultCountry = resData?.data?.find(
                (c) => c.name && c.name.toLowerCase() === "india"
              ) || resData?.data?.[0];
              if (defaultCountry) {
                form.setFieldsValue({ country: defaultCountry.id });
                handleCountryChange(defaultCountry.id, "dataSet", "billing");
              }
            }
          }
        })
        .catch((error) => {
          console.error("Error on Customer form : ", error);
          message.error("Unable to fetch country", 2);
        });
    }
  }, [open, data]);

  const setReferredCustomer = (id) => {
    platformApi.get("api/customer/reffered/" + id).then((result) => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setReferredList(response.data);
        }
      }
    });
  };

  useEffect(() => {
    setEditable(props.phone != undefined ? true : props.editable);
    if (data) {
      data.phone &&
        setDataSource([
          {
            id: "",
            phone: data.phone,
            type: "Primary",
            valid: true,
            DND: false,
            WhatsApp: data.WhatsApp,
          },
        ]);
      data && handleCustomerType(data.customerType);
      data && data.contacts && setDataSource(data.contacts);
      numberCheck(data && data.contacts);
      if (data && data.address) {
        const stateId = data.address.state?.id || data.address.state;
        const countryId = data.address.country?.id || data.address.country;
        const cityId = data.address.city?.id || data.address.city;
        if (stateId) handleStateChange(stateId, "dataSet", "billing");
        if (countryId) handleCountryChange(countryId, "dataSet", "billing");
        if (cityId) handleCityChange(cityId, "dataSet", "billing");
      }
      if (data && data.shippingAddress) {
        const shipStateId = data.shippingAddress.state?.id || data.shippingAddress.state;
        const shipCountryId = data.shippingAddress.country?.id || data.shippingAddress.country;
        const shipCityId = data.shippingAddress.city?.id || data.shippingAddress.city;
        if (shipStateId) handleStateChange(shipStateId, "dataSet", "shipping");
        if (shipCountryId) handleCountryChange(shipCountryId, "dataSet", "shipping");
        if (shipCityId) handleCityChange(shipCityId, "dataSet", "shipping");
      }
      setCusId(data.customerId);
      let dob = undefined;
      if (data.dateOfBirth) {
        dob = moment(data.dateOfBirth);
      }
      data.GSTType === null ||
        data.GSTType === "Unregistered" ||
        data.GSTType === "UNREGISTERED"
        ? setGstType(true)
        : setGstType(false);
      data.refferedBy &&
        data.refferedBy &&
        setReferredList([data.refferedBy && data.refferedBy]);
      form.setFieldsValue({
        salutation: data.salutation || undefined,
        name: data.name,
        fatherName: data.fatherName,
        gender: data.gender ? (data.gender.toLowerCase() === "female" ? "Female" : data.gender.toLowerCase() === "male" ? "Male" : data.gender) : undefined,
        dateOfBirth: dob,
        country:
          data.address?.country?.id || data.address?.country || undefined,
        state:
          data.address?.state?.id || data.address?.state || undefined,
        city:
          data.address?.city?.id || data.address?.city || undefined,
        district:
          data.address?.district?.id || data.address?.district || undefined,
        locality: data.locality || data.address?.locality || "",
        // street: data.address && data.address.street,
        line1: data.address && data.address.line1,
        line2: data.address && data.address.line2,
        line3: data.address && data.address.line3,
        pincode: data.address && data.address.pincode,
        shippingLine1: data.shippingAddress && data.shippingAddress.line1,
        shippingLine2: data.shippingAddress && data.shippingAddress.line2,
        shippingLine3: data.shippingAddress && data.shippingAddress.line3,
        shippingPincode: data.shippingAddress && data.shippingAddress.pincode,
        shippingCountry:
          data.shippingAddress?.country?.id || data.shippingAddress?.country || undefined,
        shippingState:
          data.shippingAddress?.state?.id || data.shippingAddress?.state || undefined,
        shippingCity:
          data.shippingAddress?.city?.id || data.shippingAddress?.city || undefined,
        shippingDistrict:
          data.shippingAddress?.district?.id || data.shippingAddress?.district || undefined,
        shippingLocality: data.shippingAddress && data.shippingAddress.locality,
        customerType: data.customerType,
        GSTNo: data.GSTNo,
        GSTType: data.GSTType || "Unregistered",
        customerGrouping: data.customerGrouping || undefined,
        referredBy: data.refferedBy && data.refferedBy.id,
        referred: data.reffered && data.reffered,
        email: data.email,
        aadhaarNo: data.aadhaarNo,
        panCardNo: data.panCardNo,
      });
    }
  }, [props.editable, data]);

  const filterMethod = (input, option) => {
    const label = Array.isArray(option?.props?.children)
      ? option.props.children.join("")
      : String(option?.props?.children || "");
    return label.toLowerCase().indexOf((input || "").trim().toLowerCase()) >= 0;
  };

  // const filterMethodReferred = (input, option) =>
  //   option.props.children.toString().indexOf(input) >= 0;

  const handleCountryChange = (id, type, addressType = "billing") => {
    if (addressType === "billing") {
      if (type !== "dataSet") {
        form.setFieldsValue({
          city: undefined,
          district: undefined,
          state: undefined,
        });
      }
    } else if (addressType === "shipping") {
      if (type !== "dataSet") {
        form.setFieldsValue({
          shippingCity: undefined,
          shippingDistrict: undefined,
          shippingState: undefined,
        });
      }
    }
    platformApi
      .post("api/csc/states", { id })
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          if (addressType === "billing") {
            setState(data.data);
          } else {
            setShippingStates(data.data);
          }
        }
      })
      .catch((error) => {
        console.error("Error on Customer form : ", error);
        message.error("Unable to fetch state", 2);
      });
  };

  const handleStateChange = (id, type, addressType = "billing") => {
    if (addressType === "billing") {
      if (type !== "dataSet") {
        form.setFieldsValue({
          city: undefined,
          district: undefined,
        });
      }
    } else if (addressType === "shipping") {
      if (type !== "dataSet") {
        form.setFieldsValue({
          shippingCity: undefined,
          shippingDistrict: undefined,
        });
      }
    }
    // Fetch Cities
    platformApi
      .post("api/csc/cities", { id })
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          if (addressType === "billing") {
            setCity(data.data);
          } else {
            setShippingCities(data.data);
          }
        }
      })
      .catch((error) => {
        console.error("Error on Customer form : ", error);
        message.error("Unable to fetch cities", 2);
      });

    // Fetch Districts
    platformApi
      .post("api/csc/districts", { id })
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          if (addressType === "billing") {
            setDistrict(data.data);
          } else {
            setShippingDistricts(data.data);
          }
        }
      })
      .catch((error) => {
        console.error("Error on Customer form : ", error);
        message.error("Unable to fetch districts", 2);
      });
  };

  const handleCityChange = (id, type, addressType = "billing") => {
    if (type !== "dataSet") {
      if (addressType === "billing") {
        form.setFieldsValue({ locality: undefined, pincode: undefined });
        setLocalities([]);
      } else {
        form.setFieldsValue({ shippingLocality: undefined, shippingPincode: undefined });
        setShippingLocalities([]);
      }
    }
    platformApi
      .post("api/csc/localities", { id })
      .then((result) => {
        const { data } = result;
        if (data.code === 200) {
          const list = data.data || [];
          if (addressType === "billing") {
            setLocalities(list);
            const currentLoc = form.getFieldValue("locality");
            if (currentLoc) {
              const matched = list.find(
                (l) => l.id === currentLoc || l.localityName === currentLoc
              );
              if (matched) {
                form.setFieldsValue({ locality: matched.id, pincode: matched.pinCode });
              }
            }
          } else {
            setShippingLocalities(list);
            const currentShipLoc = form.getFieldValue("shippingLocality");
            if (currentShipLoc) {
              const matched = list.find(
                (l) => l.id === currentShipLoc || l.localityName === currentShipLoc
              );
              if (matched) {
                form.setFieldsValue({ shippingLocality: matched.id, shippingPincode: matched.pinCode });
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error on Customer form : ", error);
        message.error("Unable to fetch localities", 2);
      });
  };

  const handleLocalityChange = (localityVal, addressType = "billing") => {
    const list = addressType === "billing" ? localities : shippingLocalities;
    const selected = list.find((loc) => loc.id === localityVal || loc.localityName === localityVal);
    if (selected) {
      if (addressType === "billing") {
        form.setFieldsValue({ pincode: selected.pinCode });
      } else {
        form.setFieldsValue({ shippingPincode: selected.pinCode });
      }
    }
  };

  const dateChange = (e) => {
    if (e) {
      setDate(moment(e).format("DD-MM-YYYY"));
    }
  };

  const editingPhone = () => {
    if (form.getFieldValue("phone") && form.getFieldValue("phone").length === 10 && !error.PNO) {
      const obj = {
        phone: form.getFieldValue("phone"),
        type: form.getFieldValue("type"),
        valid: true,
        DND: form.getFieldValue("dnd"),
        WhatsApp: form.getFieldValue("WhatsApp"),
        id: editPhone,
      };
      let i = 0;
      dataSource?.map((element, index) => {
        if (element.id === editPhone) {
          i = index;
        }
      });
      setDataSource([]);
      const data = dataSource;
      data[i] = obj;
      setDataSource(data);
      form.setFieldsValue({
        phone: undefined,
        dnd: undefined,
        WhatsApp: undefined,
      });
      form.setFieldsValue({ type: undefined });

      // Clear edit mode after successful save
      setEditPhone("");

      // Show success message
      message.success("Phone number updated successfully");
    } else {
      message.error("Enter Valid Phone Number");
    }
  };
  const handleCustomerType = (id) => {
    if (id === "Insurance Surveyor") {
      setCheckNameNo(true);
      setCheckAll(false);
      setCheckName(true);
      setError([]);
    }
    if (id === "Service Customer") {
      setCheckNameNo(true);
      setCheckAll(false);
      setCheckName(true);
      setError([]);
      // form.resetFields()
    }
    if (id === "Sales Customer") {
      setCheckNameNo(true);
      setCheckAll(true);
      setCheckName(true);
    }
    if (id === "Non Customer") {
      setCheckNameNo(false);
      setCheckAll(false);
      setCheckName(false);
      setError([]);
      // form.resetFields()
    }
    if (!primaryNumberCheck) {
      form.setFieldsValue({
        type: types[0].key,
      });
    } else {
      form.setFieldsValue({
        type: types[1].key,
      });
    }
  };
  const clearFields = () => {
    form.resetFields();
    setDataSource([]);
    setCusId("");
    setState([]);
    setDistrict([]);
    setError({});
    setGstType(true);
    setCheckNameNo(true);
    setCheckAll(true);
    setGstName("");
  };
  return (
    <Modal
      title={<Title level={4}>Customer Details</Title>}
      visible={open}
      onCancel={() => {
        clearFields();
        setLoading(false);
        close();
      }}
      onOk={() => (editable ? handleSubmit() : setEditable(true))}
      okButtonProps={
        !editable ? { loading, style: { display: "none" } } : { loading }
      }
      cancelText={editable ? "Cancel" : "Close"}
      okText="Save"
      wrapClassName="customer-modal"
      bodyStyle={{
        minHeight: "90vh",
        overflowY: "auto",
      }}
    >
      <Tabs activeKey={activeKey} onChange={(key) => setActiveKey(key)}>
        <TabPane tab={<span>Customer Details</span>} key="1">
          <Form>
            <Row>
              <Item>
                {data ? <Text strong>Customer ID:{cusId}</Text> : <div></div>}
              </Item>
            </Row>
            <Row type="flex" justify="space-around">
              <Col span={11}>
                <Item label="Customer Type" colon={false}>
                  {getFieldDecorator("customerType", {
                    rules: [
                      { required: true, message: "Select Customer Type" },
                    ],
                  })(
                    <Select
                      disabled={!editable}
                      placeholder="Customer Type"
                      showAction={["click", "focus"]}
                      onChange={handleCustomerType}
                    >
                      {customerTypes?.map((ct) => (
                        <Select.Option key={ct.key}>{ct.title}</Select.Option>
                      ))}
                    </Select>
                  )}
                </Item>
                <Row type="flex" justify="space-between">
                  <Col span={4}>
                    <Item label="Salutation" colon={false}>
                      {getFieldDecorator("salutation", {
                        rules: [
                          { required: checkAll, message: "Select Salutation" },
                        ],
                      })(
                        <Select disabled={!editable} placeholder="Sal.">
                          {salutations?.map((sal) => (
                            <Select.Option key={sal.key}>
                              {sal.title}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>

                  <Col span={19}>
                    <Item
                      label="Customer Name"
                      colon={false}
                      validateStatus={error.NAME && error.NAME.type}
                      help={error.NAME && error.NAME.message}
                    // required
                    >
                      {getFieldDecorator("name", {
                        rules: [
                          {
                            required: checkName,
                            message: "Enter Customer  Name",
                          },
                        ],
                      })(
                        <Input
                          disabled={!editable}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              name: formatValue(e, "allCaps"),
                            })
                          }
                          placeholder="Customer Name"
                          pattern="^[A-Z][a-zA-Z.\s]*[a-zA-Z.]+$"
                          onInput={(event) => {
                            if (!event.target.checkValidity()) {
                              setError({
                                ...error,
                                NAME: {
                                  type: "error",
                                  message: "Enter Valid Name",
                                },
                              });
                            } else {
                              delete error.NAME;
                              setError(error);
                            }
                          }}
                        />
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row>
                  <Item
                    label="Father's Name / Husband's Name"
                    colon={false}
                    validateStatus={error.FATHERNAME && error.FATHERNAME.type}
                    help={error.FATHERNAME && error.FATHERNAME.message}
                  >
                    {getFieldDecorator("fatherName", {
                      rules: [
                        { required: checkAll, message: "Enter Father / Husband Name" },
                      ],
                    })(
                      <Input
                        disabled={!editable}
                        onKeyUp={(e) =>
                          form.setFieldsValue({
                            fatherName: formatValue(e, "allCaps"),
                          })
                        }
                        placeholder="Father's Name / Husband's Name"
                        pattern="^[A-Z][a-zA-Z.\s]*[a-zA-Z.]+$"
                        onInput={(event) => {
                          if (!event.target.checkValidity()) {
                            setError({
                              ...error,
                              FATHERNAME: {
                                type: "error",
                                message: "Enter Valid Name",
                              },
                            });
                          } else {
                            delete error.FATHERNAME;
                            setError(error);
                          }
                        }}
                      />
                    )}
                  </Item>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item label="Gender" colon={false}>
                      {getFieldDecorator("gender", {
                        initialValue: data?.gender ? (data.gender.toLowerCase() === "female" ? "Female" : data.gender.toLowerCase() === "male" ? "Male" : data.gender) : undefined,
                        rules: [
                          {
                            required: checkAll,
                            message: "Please Select Gender",
                          },
                        ],
                      })(
                        <Radio.Group disabled={!editable}>
                          <Radio value="Male">Male</Radio>
                          <Radio value="Female">Female</Radio>
                        </Radio.Group>
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item label="DOB" colon={false}>
                      {getFieldDecorator("dateOfBirth", {
                        rules: [
                          {
                            required: checkAll,
                            message: "Enter DOB",
                          },
                        ],
                      })(
                        <DatePicker
                          style={{ width: "100%" }}
                          size={date}
                          format="DD/MM/YYYY"
                          placeholder="DD/MM/YYYY"
                          disabled={!editable}
                          allowClear
                          onChange={(e) => dateChange(e)}
                          disabledDate={(moment) => Date.now() < moment._d}
                        />
                      )}
                    </Item>
                  </Col>
                </Row>
                <Item
                  label={
                    <Text style={{ fontSize: "15px" }}>
                      <span style={{ color: "crimson" }}> * </span>
                      Contacts
                    </Text>
                  }
                  colon={false}
                >
                  {getFieldDecorator("contact", {
                    rules: [
                      {
                        required: false,
                        message: "Enter Contacts",
                      },
                    ],
                  })(
                    <Table
                      locale={{
                        emptyText: (
                          <Empty
                            imageStyle={{
                              height: 25,
                              fontSize: 30,
                            }}
                            description={
                              <Text disabled strong>
                                No Contacts
                              </Text>
                            }
                            image={<Icon type="contacts" />}
                          />
                        ),
                      }}
                      rowKey={(record) => record.id}
                      pagination={false}
                      size="small"
                      columns={column.filter(
                        (columns) =>
                          columns.title.props.children !== "Action" || editable
                      )}
                      style={{ cursor: "pointer" }}
                      dataSource={dataSource}
                    />
                  )}
                </Item>
                <Row type="flex" justify="space-between" style={{ marginBottom: 12 }}>
                  <Col span={7}>
                    <Item
                      label="Phone"
                      colon={false}
                      validateStatus={error.PNO && error.PNO.type}
                      help={error.PNO && error.PNO.message}
                    // required
                    >
                      {getFieldDecorator("phone", {
                        initialValue: props.phone !== undefined ? props.phone : undefined,
                        rules: [{ required: false, message: "Enter Phone" }],
                      })(
                        <Input
                          onWheel={(event) => event.currentTarget.blur()}
                          disabled={!editable}
                          placeholder="Phone"
                          pattern="^[0-9]{10}$"
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              phone: formatValue(e, "onlyNo"),
                            })
                          }
                          onChange={(event) => {
                            if (!event.target.checkValidity()) {
                              setError({
                                ...error,
                                PNO: {
                                  type: "error",
                                  message: "Enter Valid Phone Number",
                                },
                              });
                            } else {
                              delete error.PNO;
                              setError(error);
                            }
                            if (dataSource.length > 0) {
                              if (event.target.checkValidity()) {
                                for (
                                  let i = 0;
                                  i < dataSource.length;
                                  i = i + 1
                                ) {
                                  if (
                                    dataSource[i].phone == event.target.value
                                  ) {
                                    setError({
                                      ...error,
                                      PNO: {
                                        type: "error",
                                        message: "Phone Number already exists",
                                      },
                                    });
                                  } else {
                                    delete error.PNO;
                                    setError(error);
                                  }
                                }
                              }
                            }
                          }}
                          addonBefore="+91"
                          maxLength={10}
                        />
                      )}
                    </Item>
                  </Col>
                  <Col span={7}>
                    <Item label="Type" colon={false}>
                      {getFieldDecorator("type", {
                        rules: [{ required: false, message: "Enter type" }],
                      })(
                        <Select
                          placeholder="Type"
                          showAction={["click", "focus"]}
                          disabled={!editable}
                        >
                          {primaryNumberCheck ? (
                            <Select.Option
                              key={types[1].key}
                              value={types[1].key}
                            >
                              {types[1].title}
                            </Select.Option>
                          ) : (
                            <Select.Option
                              key={types[0].key}
                              value={types[0].key}
                            >
                              {types[0].title}
                            </Select.Option>
                          )}
                        </Select>
                      )}
                    </Item>
                  </Col>
                  <Col span={7}>
                    <Item label="WhatsApp" colon={false}>
                      {getFieldDecorator("WhatsApp", {
                        rules: [{ required: false, message: "Enter type" }],
                      })(
                        <Select
                          placeholder="WhatsApp"
                          showAction={["click", "focus"]}
                          disabled={!editable}
                        >
                          <Select.Option key={true} value={true}>
                            Yes
                          </Select.Option>
                          <Select.Option key={false} value={false}>
                            No
                          </Select.Option>
                        </Select>
                      )}
                    </Item>
                  </Col>
                </Row>

                <Row type="flex" justify="space-between" style={{ marginBottom: 12 }}>
                  <Col span={11}>
                    <Item label="DND" colon={false}>
                      {getFieldDecorator("dnd", {
                        rules: [{ required: false, message: "Enter DND" }],
                      })(
                        <Select
                          placeholder="DND"
                          showAction={["click", "focus"]}
                          disabled={!editable}
                        >
                          <Select.Option key={true} value={true}>
                            Yes
                          </Select.Option>
                          <Select.Option key={false} value={false}>
                            No
                          </Select.Option>
                        </Select>
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    {editable && (
                      <Item label=" " colon={false}>
                        {!editPhone ? (
                          <Button
                            style={{ width: "100%" }}
                            type="primary"
                            disabled={!editable}
                            onClick={() => {
                              if (
                                form.getFieldValue("phone") &&
                                form.getFieldValue("phone").length === 10 &&
                                !error.PNO
                              ) {
                                const obj = {
                                  id: "",
                                  phone: form.getFieldValue("phone"),
                                  type: form.getFieldValue("type"),
                                  valid: true,
                                  WhatsApp: form.getFieldValue("WhatsApp"),
                                  DND: form.getFieldValue("dnd"),
                                };
                                if (obj.type === "Primary") {
                                  types.shift();
                                }
                                setDataSource([...dataSource, obj]);
                                form.setFieldsValue({
                                  phone: undefined,
                                  type: "Alternate",
                                  dnd: undefined,
                                  WhatsApp: undefined
                                });
                              } else {
                                message.error("Enter valid Phone number");
                              }
                            }}
                          >
                            Add Contact
                          </Button>
                        ) : (
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <Button
                              style={{ width: "48%" }}
                              onClick={() => {
                                // Cancel edit mode
                                setEditPhone("");
                                form.setFieldsValue({
                                  phone: undefined,
                                  type: undefined,
                                  dnd: undefined,
                                  WhatsApp: undefined,
                                });
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              type="primary"
                              style={{ width: "48%" }}
                              onClick={() => editingPhone()}
                            >
                              Save
                            </Button>
                          </div>
                        )}
                      </Item>
                    )}
                  </Col>
                </Row>

                <Row type="flex" justify="space-between" style={{ marginBottom: 12 }}>
                  <Col span={24}>
                    <Item
                      label="E-mail"
                      colon={false}
                      validateStatus={error.EMAIL && error.EMAIL.type}
                      help={error.EMAIL && error.EMAIL.message}
                    >
                      {getFieldDecorator("email", {
                        rules: [
                          {
                            required: false,
                            message: "Enter email"
                          },
                          {
                            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Please enter a valid email",
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value && value.length > 0) {
                                // Check if email has valid format
                                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                if (!emailRegex.test(value)) {
                                  callback("Please enter a valid email address");
                                } else {
                                  callback();
                                }
                              } else {
                                callback(); // Empty is allowed since optional
                              }
                            },
                          },
                        ],
                      })(
                        <Input
                          disabled={!editable}
                          placeholder="E-mail (Optional)"
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              email: formatValue(e, "toLowerCase"),
                            })
                          }
                          onWheel={(event) => event.currentTarget.blur()}
                          maxLength={50}
                          onChange={(event) => {
                            const value = event.target.value;
                            if (value && value.length > 0) {
                              const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                              if (!emailRegex.test(value)) {
                                setError({
                                  ...error,
                                  EMAIL: {
                                    type: "error",
                                    message: "Please enter a valid email",
                                  },
                                });
                              } else {
                                delete error.EMAIL;
                                setError(error);
                              }
                            } else {
                              delete error.EMAIL;
                              setError(error);
                            }
                          }}
                        />
                      )}
                    </Item>
                  </Col>
                </Row>

                <Row type="flex" justify="space-between" style={{ marginBottom: 12 }}>
                  <Col span={11}>
                    <Item
                      label="Aadhaar No"
                      colon={false}
                      validateStatus={error.AADHAAR && error.AADHAAR.type}
                      help={error.AADHAAR && error.AADHAAR.message}
                    >
                      {getFieldDecorator("aadhaarNo", {
                        getValueFromEvent: (event) => event.target.value.toUpperCase(),
                        rules: [
                          {
                            required: false,
                            message: "Enter Aadhaar No"
                          },
                          {
                            pattern: /^[0-9]{12}$/,
                            message: "Enter a valid Aadhaar number",
                          }
                        ],
                      })(
                        <Input
                          style={{ textTransform: "uppercase" }}
                          disabled={!editable}
                          placeholder="Aadhaar No"
                          maxLength={12}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              aadhaarNo: formatValue(e, "toUpperCase"),
                            })
                          }
                          onChange={(event) => {
                            const value = event.target.value.toUpperCase();
                            if (value && value.length > 0) {
                              if (!/^[0-9]{12}$/.test(value)) {
                                setError({
                                  ...error,
                                  AADHAAR: {
                                    type: "error",
                                    message: "Enter a valid Aadhaar number",
                                  },
                                });
                              } else {
                                const newErrors = { ...error };
                                delete newErrors.AADHAAR;
                                setError(newErrors);
                              }
                            } else {
                              const newErrors = { ...error };
                              delete newErrors.AADHAAR;
                              setError(newErrors);
                            }
                          }}
                        />
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item
                      label="Pancard No"
                      colon={false}
                      validateStatus={error.PAN && error.PAN.type}
                      help={error.PAN && error.PAN.message}
                    >
                      {getFieldDecorator("panCardNo", {
                        getValueFromEvent: (event) => event.target.value.toUpperCase(),
                        rules: [
                          {
                            required: false,
                            message: "Enter Pancard No"
                          },
                          {
                            pattern: /^[A-Z0-9]{10}$/,
                            message: "Enter a valid PAN Card number",
                          }
                        ],
                      })(
                        <Input
                          style={{ textTransform: "uppercase" }}
                          disabled={!editable}
                          placeholder="Pancard No"
                          maxLength={10}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              panCardNo: formatValue(e, "toUpperCase"),
                            })
                          }
                          onChange={(event) => {
                            const value = event.target.value.toUpperCase();
                            if (value && value.length > 0) {
                              if (!/^[A-Z0-9]{10}$/.test(value)) {
                                setError({
                                  ...error,
                                  PAN: {
                                    type: "error",
                                    message: "Enter a valid PAN Card number",
                                  },
                                });
                              } else {
                                const newErrors = { ...error };
                                delete newErrors.PAN;
                                setError(newErrors);
                              }
                            } else {
                              const newErrors = { ...error };
                              delete newErrors.PAN;
                              setError(newErrors);
                            }
                          }}
                        />
                      )}
                    </Item>
                  </Col>
                </Row>

                <Row type="flex" justify="space-between" style={{ marginBottom: 12 }}>
                  <Col span={11}>
                    <Item label="GST Type" colon={false}>
                      {getFieldDecorator("GSTType", {
                        initialValue: "Unregistered",
                      })(
                        <Select
                          showAction={["click", "focus"]}
                          placeholder="GST Type"
                          disabled={!editable}
                          onChange={(event) => {
                            event === "Unregistered"
                              ? (setGstType(true),
                                form.setFieldsValue({ GSTNo: undefined }),
                                delete error.GST,
                                setError(error),
                                setGstName(""))
                              : setGstType(false);
                          }}
                        >
                          <Select.Option key="Registered" value="Registered">
                            Registered
                          </Select.Option>
                          <Select.Option
                            key="Unregistered"
                            value="Unregistered"
                          >
                            Unregistered
                          </Select.Option>
                          <Select.Option key="UINHolder" value="UINHolder">
                            UIN Holder
                          </Select.Option>
                          <Select.Option key="Composition" value="Composition">
                            Composition
                          </Select.Option>
                        </Select>
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item
                      label="GSTIN"
                      colon={false}
                      validateStatus={error.GST && error.GST.type}
                      help={error.GST && error.GST.message}
                    >
                      {getFieldDecorator("GSTNo", {
                        rules: [
                          {
                            required: !gstType,
                            message: "Enter GST",
                          },
                        ],
                      })(
                        <Input
                          style={{ textTransform: "uppercase" }}
                          maxLength={15}
                          onKeyUp={(event) => {
                            setFieldsValue({
                              GSTNo: formatValue(event, "toUpperCase"),
                            });
                          }}
                          disabled={gstType || !editable}
                          placeholder="GST"
                          onInput={(event) => {
                            if (event.target.value.length === 15) {
                              let flag = checkGST(event.target.value);
                              if (flag) {
                                delete error.GST;
                                setError(error);
                              } else {
                                setError({
                                  ...error,
                                  GST: {
                                    type: "error",
                                    message: "Enter Valid GSTIN",
                                  },
                                });
                              }
                            } else if (gstStatus != "Active") {
                              setGstStatus("");
                              setGstName("");
                              setError({
                                ...error,
                                GST: {
                                  type: "error",
                                  message: "The GSTIN entered is Inactive",
                                },
                              });
                            } else {
                              setGstName("");
                              setError({
                                ...error,
                                GST: {
                                  type: "error",
                                  message: "Enter Valid GSTIN",
                                },
                              });
                            }
                          }}
                        />
                      )}
                    </Item>
                    {gstName && (
                      <Row type="flex" align="middle">
                        <Icon
                          style={{ fontSize: 18, marginRight: ".5rem" }}
                          type="check-circle"
                          twoToneColor="#D00"
                        />
                        <span style={{ color: "green", fontSize: "10px" }}>
                          {gstName} ({gstStatus})
                        </span>
                      </Row>
                    )}
                  </Col>
                </Row>
                <Row type="flex" justify="space-between" style={{ marginBottom: 12 }}>
                  <Col span={24}>
                    <Item label="Customer Grouping" colon={false}>
                      {getFieldDecorator("customerGrouping", {
                        rules: [
                          {
                            required: checkAll,
                            message: "Select Customer Grouping",
                          },
                        ],
                      })(
                        <Select
                          showAction={["click", "focus"]}
                          disabled={!editable}
                          placeholder="Customer Grouping"
                        >
                          {customerGrouping?.map((Grouping) => (
                            <Select.Option key={Grouping.key}>
                              {Grouping.title}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                </Row>
              </Col>
              <br />
              <br />
              <br />
              <Col span={11}>
                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 15 }}>
                  Billing Address
                </div>

                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item
                      label="Address Line 1"
                      colon={false}
                      validateStatus={error.LINE1 && error.LINE1.type}
                      help={error.LINE1 && error.LINE1.message}
                    >
                      {getFieldDecorator("line1", {
                        rules: [
                          {
                            required: checkAll,
                            message: "Enter Door No. / Street Name",
                          },
                        ],
                      })(
                        <Input
                          disabled={!editable}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              line1: formatValue(e, "allCaps"),
                            })
                          }
                          placeholder="Address Line 1"
                          maxLength={50}
                        />
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item
                      label="Address line 2"
                      colon={false}
                      validateStatus={error.LINE2 && error.LINE2.type}
                      help={error.LINE2 && error.LINE2.message}
                    >
                      {getFieldDecorator("line2", {
                        rules: [
                          {
                            required: false,
                            message: "Enter Door No. / Street Name",
                          },
                        ],
                      })(
                        <Input
                          disabled={!editable}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              line2: formatValue(e, "allCaps"),
                            })
                          }
                          placeholder="Address Line 2"
                          maxLength={50}
                        />
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item
                      label="Address line 3"
                      colon={false}
                      validateStatus={error.DOOR && error.DOOR.type}
                      help={error.DOOR && error.DOOR.message}
                    >
                      {getFieldDecorator("line3", {
                        rules: [
                          {
                            required: false,
                            message: "Enter Door No. / Street Name",
                          },
                        ],
                      })(
                        <Input
                          disabled={!editable}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              line3: formatValue(e, "allCaps"),
                            })
                          }
                          placeholder="Address Line 3"
                          maxLength={50}
                        />
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item label="Country" colon={false}>
                      {getFieldDecorator("country", {
                        rules: [
                          { required: checkAll, message: "Select Country" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable}
                          placeholder="Country"
                          onChange={(value) => handleCountryChange(value, "change", "billing")}
                          filterOption={filterMethod}
                        >
                          {country?.map((object) => (
                            <Select.Option value={object.id} key={object.id}>
                              {object.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item label="State" colon={false}>
                      {getFieldDecorator("state", {
                        rules: [
                          { required: checkAll, message: "Select State" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || state.length == 0}
                          placeholder="State"
                          filterOption={filterMethod}
                          onChange={(value) => handleStateChange(value, "change", "billing")}
                        >
                          {state?.map((object) => (
                            <Select.Option value={object.id} key={object.id}>
                              {object.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item label="City" colon={false}>
                      {getFieldDecorator("city", {
                        rules: [
                          { required: checkAll, message: "Select City" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || city.length == 0}
                          placeholder="City"
                          filterOption={filterMethod}
                          onChange={(value) => handleCityChange(value, "change", "billing")}
                        >
                          {city?.map((object) => (
                            <Select.Option key={object.id} value={object.id}>
                              {object.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item label="District" colon={false}>
                      {getFieldDecorator("district", {
                        rules: [
                          { required: checkAll, message: "Select District" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || district.length == 0}
                          placeholder="District"
                          filterOption={filterMethod}
                        >
                          {district?.map((object) => (
                            <Select.Option key={object.id} value={object.id}>
                              {object.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item
                      label="Locality"
                      colon={false}
                    >
                      {getFieldDecorator("locality", {
                        rules: [
                          { required: checkAll, message: "Select Locality" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || localities.length == 0}
                          placeholder="Locality"
                          filterOption={filterMethod}
                          onChange={(value) => handleLocalityChange(value, "billing")}
                        >
                          {localities?.map((object) => (
                            <Select.Option key={object.id} value={object.id}>
                              {object.localityName}{object.pinCode ? ` - ${object.pinCode}` : ""}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item
                      label="Pincode"
                      colon={false}
                    >
                      {getFieldDecorator("pincode", {
                        rules: [
                          { required: checkAll, message: "Enter pincode" },
                        ],
                      })(
                        <Input
                          disabled={true}
                          placeholder="Pincode"
                          maxLength={7}
                        />
                      )}
                    </Item>
                  </Col>
                </Row>
                <br />
                <br />

                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 15 }}>
                  Shipping Address
                </div>
                <Row style={{ marginBottom: 16 }}>
                  <Col span={24}>
                    <Checkbox
                      checked={sameAsBilling}
                      onChange={handleSameAsBillingChange}
                      disabled={!editable}
                    >
                      Shipping address same as Billing address
                    </Checkbox>
                  </Col>
                </Row>


                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item
                      label="Address Line 1"
                      colon={false}
                      validateStatus={error.SHIPPING_LINE1 && error.SHIPPING_LINE1.type}
                      help={error.SHIPPING_LINE1 && error.SHIPPING_LINE1.message}
                    >
                      {getFieldDecorator("shippingLine1", {
                        rules: [
                          {
                            required: checkAll && !sameAsBilling,
                            message: "Enter Door No. / Street Name",
                          },
                        ],
                      })(
                        <Input
                          disabled={!editable || sameAsBilling}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              shippingLine1: formatValue(e, "allCaps"),
                            })
                          }
                          placeholder="Address Line 1"
                          maxLength={50}
                        />
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item
                      label="Address line 2"
                      colon={false}
                      validateStatus={error.SHIPPING_LINE2 && error.SHIPPING_LINE2.type}
                      help={error.SHIPPING_LINE2 && error.SHIPPING_LINE2.message}
                    >
                      {getFieldDecorator("shippingLine2", {
                        rules: [
                          {
                            required: false,
                            message: "Enter Door No. / Street Name",
                          },
                        ],
                      })(
                        <Input
                          disabled={!editable || sameAsBilling}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              shippingLine2: formatValue(e, "allCaps"),
                            })
                          }
                          placeholder="Address Line 2"
                          maxLength={50}
                        />
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item
                      label="Address line 3"
                      colon={false}
                      validateStatus={error.SHIPPING_DOOR && error.SHIPPING_DOOR.type}
                      help={error.SHIPPING_DOOR && error.SHIPPING_DOOR.message}
                    >
                      {getFieldDecorator("shippingLine3", {
                        rules: [
                          {
                            required: false,
                            message: "Enter Door No. / Street Name",
                          },
                        ],
                      })(
                        <Input
                          disabled={!editable || sameAsBilling}
                          onKeyUp={(e) =>
                            form.setFieldsValue({
                              shippingLine3: formatValue(e, "allCaps"),
                            })
                          }
                          placeholder="Address Line 3"
                          maxLength={50}
                        />
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item label="Country" colon={false}>
                      {getFieldDecorator("shippingCountry", {
                        rules: [
                          { required: checkAll && !sameAsBilling, message: "Select Country" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || sameAsBilling}
                          placeholder="Country"
                          onChange={(value) => {
                            handleCountryChange(value, "change", "shipping");
                          }}
                          filterOption={filterMethod}
                        >
                          {country?.map((object) => (
                            <Select.Option value={object.id} key={object.id}>
                              {object.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item label="State" colon={false}>
                      {getFieldDecorator("shippingState", {
                        rules: [
                          { required: checkAll && !sameAsBilling, message: "Select State" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || sameAsBilling}
                          placeholder="State"
                          filterOption={filterMethod}
                          onChange={(value) => {
                            handleStateChange(value, "change", "shipping");
                          }}
                        >
                          {(sameAsBilling ? state : shippingStates)?.map((object) => (
                            <Select.Option value={object.id} key={object.id}>
                              {object.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item label="City" colon={false}>
                      {getFieldDecorator("shippingCity", {
                        rules: [
                          { required: checkAll && !sameAsBilling, message: "Select City" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || sameAsBilling}
                          placeholder="City"
                          filterOption={filterMethod}
                          onChange={(value) => {
                            handleCityChange(value, "change", "shipping");
                          }}
                        >
                          {(sameAsBilling ? city : shippingCities)?.map((object) => (
                            <Select.Option key={object.id} value={object.id}>
                              {object.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item label="District" colon={false}>
                      {getFieldDecorator("shippingDistrict", {
                        rules: [
                          { required: checkAll && !sameAsBilling, message: "Select District" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || sameAsBilling}
                          placeholder="District"
                          filterOption={filterMethod}
                        >
                          {(sameAsBilling ? district : shippingDistricts)?.map((object) => (
                            <Select.Option key={object.id} value={object.id}>
                              {object.name}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                  <Col span={11}>
                    <Item
                      label="Locality"
                      colon={false}
                    >
                      {getFieldDecorator("shippingLocality", {
                        rules: [
                          { required: checkAll && !sameAsBilling, message: "Select Locality" },
                        ],
                      })(
                        <Select
                          showSearch
                          showAction={["click", "focus"]}
                          disabled={!editable || sameAsBilling || (sameAsBilling ? localities : shippingLocalities).length == 0}
                          placeholder="Locality"
                          filterOption={filterMethod}
                          onChange={(value) => handleLocalityChange(value, "shipping")}
                        >
                          {(sameAsBilling ? localities : shippingLocalities)?.map((object) => (
                            <Select.Option key={object.id} value={object.id}>
                              {object.localityName}{object.pinCode ? ` - ${object.pinCode}` : ""}
                            </Select.Option>
                          ))}
                        </Select>
                      )}
                    </Item>
                  </Col>
                </Row>
                <Row type="flex" justify="space-between">
                  <Col span={11}>
                    <Item
                      label="Pincode"
                      colon={false}
                    >
                      {getFieldDecorator("shippingPincode", {
                        rules: [
                          { required: checkAll && !sameAsBilling, message: "Enter pincode" },
                        ],
                      })(
                        <Input
                          disabled={true}
                          placeholder="Pincode"
                          maxLength={7}
                        />
                      )}
                    </Item>
                  </Col>
                </Row>

                {data && (
                  <Row>
                    <Col span={24}>
                      <Item label="Referred Customers" colon={false}>
                        {referredList.length > 0 ? (
                          referredList?.map((referred) => {
                            return (
                              <Tag
                                key={true}
                                style={{ cursor: "pointer" }}
                                color="#006a71"
                              >
                                <Link
                                  key={true}
                                  style={{ color: "#2db7f5" }}
                                  target="_blank"
                                  to={`referred_customer/?id=${referred?.id}`}
                                >
                                  {referred.name} -{" "}
                                  {referred.contacts &&
                                    referred.contacts[0].phone}
                                </Link>
                              </Tag>
                            );
                          })
                        ) : (
                          <Tag color="#006a71">No Referred Customer</Tag>
                        )}
                      </Item>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Form>
        </TabPane>

        {data && <TabPane tab={<span>Associated Vehicles</span>} key="2">
          {data && data?.purchasedVehicle && data?.purchasedVehicle?.length > 0 ? (
            <AssociatedVehicle data={data && data.purchasedVehicle} />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No bookings found for this customer"
            />
          )}
        </TabPane>}

        {data && <TabPane tab={<span>Bookings</span>} key="3">
          {data && data?.booking && data?.booking?.length > 0 ? (
            <AssociatedBookings dataSource={data && data.booking} phone={data.contacts[0].phone} refreshData={() => refreshData(selectedData.customer.id)} />
          ) : (
            <>
              <AssociatedBookings phone={data.contacts[0].phone} refreshData={() => refreshData(selectedData.customer.id)} />
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No bookings found for this customer"
              />
            </>
          )}
        </TabPane>}

        {data && <TabPane tab={<span>Quotations</span>} key="4">
          {data && data.quotation && data.quotation.length > 0 ? (
            <AssociatedQuotations
              dataSource={data.quotation}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No quotations found for this customer"
            />
          )}
        </TabPane>}

        {data && <TabPane tab={<span>Job Orders</span>} key="5">
          {selectedData && selectedData.jobOrders && selectedData.jobOrders.length > 0 ? (
            <AssociatedJobOrder
              dataSource={selectedData.jobOrders}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Job order found for this customer"
            />
          )}
        </TabPane>}

        {data && <TabPane tab={<span>Spare Orders</span>} key="6">
          {selectedData && selectedData.spareOrders && selectedData.spareOrders.length > 0 ? (
            <AssociatedSpares
              dataSource={selectedData.spareOrders}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Spare order found for this customer"
            />
          )}
        </TabPane>}

        {data && <TabPane tab={<span>Call History</span>} key="7">
          {selectedData && selectedData.telecmiCallHistory && selectedData.telecmiCallHistory.length > 0 ? (
            <CallHistory
              dataSource={selectedData.telecmiCallHistory}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Call logs found for this customer"
            />
          )}
        </TabPane>}

        {data && <TabPane tab={<span>Number Plates</span>} key="8">
          {selectedData && selectedData.numberPlates && selectedData.numberPlates.length > 0 ? (
            <AssociatedNumberPlates
              dataSource={selectedData.numberPlates}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Number plate found for this customer"
            />
          )}
        </TabPane>}
        {data && (
          <TabPane tab={<span>Payments</span>} key="9">
            {selectedData?.customer?.booking?.length > 0 ? (
              (() => {
                // Flatten all payments from all bookings
                const allPayments = selectedData.customer.booking
                  ?.map((b) =>
                    (b.payments || [])?.map((p) => ({
                      ...p,
                      bookingId: b.bookingId, // optional: track which booking this payment belongs to
                    }))
                  )
                  .flat();

                return allPayments.length > 0 ? (
                  <AssociatedPayments dataSource={allPayments} />
                ) : (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="No payments found for this customer"
                  />
                );
              })()
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No bookings found for this customer"
              />
            )}
          </TabPane>
        )}


      </Tabs>
    </Modal>
  );
};
const WrappedAccessoriesModal = Form.create({ name: "customer_details" })(
  CustomerDetailsForm
);
export default withRouter(WrappedAccessoriesModal);